import type { WidgetOptions } from "@/shared/types/widgetOptions";
import type { widgetOption } from "@/widgetMenu/widgetMenu";

interface SetNewOptionsArgs {
    name: WidgetOptions;
    setWidgetMenuOptions: (
        update: (prev: Map<WidgetOptions, widgetOption[]>) => Map<WidgetOptions, widgetOption[]>,
    ) => void;
}

export function setNewOptions({ name, setWidgetMenuOptions }: SetNewOptionsArgs) {
    return (options: widgetOption[]) => {
        setWidgetMenuOptions((prevMap) => {
            const newMap = new Map(prevMap);
            newMap.set(name, options);
            return newMap;
        });
    };
}
